var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_88_919)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00644 1C7.72963 1.00011 6.47135 1.30554 5.3366 1.89082C4.20184 2.4761 3.2235 3.32425 2.48321 4.36452C1.74293 5.40478 1.26215 6.60698 1.081 7.87083C0.899848 9.13468 1.02358 10.4235 1.44186 11.6298C1.86014 12.8361 2.56085 13.9249 3.48552 14.8054C4.41019 15.6858 5.53201 16.3324 6.75739 16.6911C7.98278 17.0498 9.27618 17.1103 10.5297 16.8676C11.7832 16.6248 12.9605 16.0858 13.9633 15.2955L17.4036 18.7356C17.5812 18.9072 17.8192 19.0021 18.0662 19C18.3132 18.9978 18.5494 18.8988 18.7241 18.7241C18.8987 18.5495 18.9978 18.3132 19 18.0662C19.0021 17.8192 18.9072 17.5813 18.7356 17.4036L15.2953 13.9635C16.226 12.7829 16.8055 11.364 16.9675 9.86941C17.1295 8.3748 16.8674 6.86478 16.2112 5.51217C15.555 4.15955 14.5312 3.019 13.2571 2.22102C11.9829 1.42305 10.5099 0.999899 9.00644 1ZM2.88335 9.00682C2.88335 7.38294 3.52846 5.82556 4.67676 4.6773C5.82506 3.52904 7.3825 2.88396 9.00644 2.88396C10.6304 2.88396 12.1878 3.52904 13.3361 4.6773C14.4844 5.82556 15.1295 7.38294 15.1295 9.00682C15.1295 10.6307 14.4844 12.1881 13.3361 13.3363C12.1878 14.4846 10.6304 15.1297 9.00644 15.1297C7.3825 15.1297 5.82506 14.4846 4.67676 13.3363C3.52846 12.1881 2.88335 10.6307 2.88335 9.00682Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_88_919"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.d8692d3dbc2b4f0782b069932c75fd6b.svg";
export { ForwardRef as ReactComponent };